<template>
  <v-card
    style="height: 100%; border-radius: 10px; box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15)"
    :class="{ 'grey lighten-1': disabled }"
  >
    <v-card-text>
      <!-- <p class="ma-0"> -->
      <div style="display: flex"><slot></slot></div>
      <!-- </p> -->
      <div :class="head ? 'fs-32 text-xs-center bold' : 'fs-24 text-xs-center bold'">
        <div v-if="disabled">-</div>
        <template v-else>
          <v-progress-circular
            indeterminate
            color="primary"
            size="25"
            v-if="loading"
          ></v-progress-circular>
          <template v-else-if="value === false"> N/A </template>
          <tween-num
            v-else
            :value="parseInt(value)"
            :initial="0"
            :formatter="numberFormat"
          ></tween-num>
        </template>
      </div>

      <div class="text-xs-right">
        <Typography h5 medium :label="label" />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import TweenNum from 'vue-tween-number'
import numeral from 'numeral'
import Typography from '@/components/elements/Typography.vue'

export default {
  props: ['value', 'loading', 'disabled', 'head','label'],
  data: function () {
    return { head: false,label:this.label }
  },
  mounted: function () {
    this.head = this.head
  },
  components: {
    TweenNum,
    PulseLoader,
    Typography,
  },
  methods: {
    numberFormat: function (val) {
      return numeral(val).format('0,0')
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/StatCard.vue